export default __webpack_public_path__ + "static/media/login.c0c19451.png";